import { emailOTPClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { getBaseURL } from './base-url';

export const authClient = createAuthClient({
  baseURL: `${getBaseURL()}/api/auth`,
  plugins: [emailOTPClient()],
});

export const { useSession, signOut } = authClient;
